import updatePropertiesWithSelector from './updatePropertiesWithSelector';
import {updateSelectedPropertyMappings, updateResolvedSelectedPropertyMappings} from '../utils';

export default function applyUpdatesForSelectableProps({
	name,
	value,
	propertiesWithSelector,
	componentId,
	propertyDetails,
	componentRegistry,
	normalizedConfigForProp
}) {
	updatePropertiesWithSelector(name, value, propertiesWithSelector);
	updateSelectedPropertyMappings(value, name, componentId);
	updateResolvedSelectedPropertyMappings(
		propertyDetails,
		name,
		componentId,
		componentRegistry,
		normalizedConfigForProp,
		propertiesWithSelector
	);
}
